import { BidraSammen, InventoryManager, Connect4, LoanCalculator, WMW, ReactToDo, JSToDo } from "../components/projects"

export const projects = [
  {
    name: "Inventory Manager",
    description: "An inventory manager done with React and Node.js with Express.",
    gitHub: "https://github.com/jopemamo/inventory-manager",
    modal: true,
    component: InventoryManager,
    link: "https://inventory-manager-ttse.onrender.com/",
  },
  {
    name: "Connect4",
    description: "A connect four game done with React.",
    gitHub: "https://github.com/jopemamo/connect4",
    modal: true,
    component: Connect4,
    link: "https://connect4-jopemamo.netlify.app/",
  },
  {
    name: "Persona",
    description: "The page where you are at right now! Done with React.",
    gitHub: "https://github.com/jopemamo/persona-Page",
    modal: false,
  },
  {
    name: "LoanCalculator",
    description: "A Loan Calculator done with React.",
    gitHub: "https://github.com/jopemamo/loan-calculator",
    modal: true,
    component: LoanCalculator,
    link: "https://loan-calculator-jopemamo.netlify.app/" ,
  },
  {
    name: "BidraSammen",
    description: "Our Graduation Project at Salt. An App done with React Native.",
    gitHub: "https://github.com/jopemamo/Graduation-Project",
    modal: true,
    component: BidraSammen,
    link: "https://res.cloudinary.com/diggrhtle/video/upload/v1604416370/persona%20page/Cloud0x9_Product_Demo_rjclga.mp4",
  },
  {
    name: "Which Movie is Worse?",
    description: "A game where you need to guess which movie has the worse rating! Done with React",
    gitHub: "https://github.com/jopemamo/Which-movie-is-worse-Game",
    modal: true,
    component: WMW,
    link: "https://which-movie-is-worse.onrender.com/",
  },
  {
    name: "React ToDo App",
    description: "A ToDo App done with React",
    gitHub: "https://github.com/jopemamo/React-ToDo-app",
    modal: true,
    component: ReactToDo,
    link: "https://react-todo-jopemamo.netlify.app/",
  },
  {
    name: "JavaScript ToDo App",
    description: "A ToDo App done with Vanilla JavaScript",
    gitHub: "https://github.com/jopemamo/Vanilla-JavaScript-ToDo-App",
    modal: true,
    component: JSToDo,
    link: "https://js-todo-jopemamo.netlify.app/",
  },
]